import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { StreetAddressViewModel } from '../StreetAddress';
import LoadingPanel from '../LoadingPanel';
import LoadingButton from '../LoadingButton';
import Receipt from '../Receipt';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    accountId: string;
    year: string;
}>;

type State = {
    accountId: number;
    year: number;
    receipts: ReceiptData[];
    errors: AlertData[];
    warnings: AlertData[];
    isGenerated: boolean;
    isLoading: boolean;
}

export interface ReceiptData {
    LogoPath: string;
    TenantName: string;
    AccountID: number;
    Number: number;
    TaxReceiptDate: Date;
    FacilityName: string;
    FacilityAddress: StreetAddressViewModel;
    BillingName: string;
    BillingAddress: StreetAddressViewModel;
    Amount: number;
    Children: string[];
}

type AlertData = {
    Message: string;
    Link: string;
}

export default class AccountReceiptPreview extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            accountId: 0,
            year: 0,
            receipts: [],
            errors: [],
            warnings: [],
            isGenerated: false,
            isLoading: false,
        };

        this.generate = this.generate.bind(this);
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Receipt" />
            <div className="form-row py-2 d-print-none">
                <div className="col-auto ml-auto">
                    <button role="button" className="btn btn-primary" onClick={() => { window.print() }}>Print Receipt</button>
                    &nbsp;
                    {this.state.receipts.length > 0 && this.state.errors.length === 0 && !this.state.isGenerated &&
                        <LoadingButton className="btn btn-success" onClick={() => confirm("Finalize Receipt?") && this.generate()} isLoading={this.state.isLoading}>Finalize Receipt</LoadingButton>
                    }
                </div>
            </div>
            {this.state.errors.map((error, index) => {
                return <div className="alert alert-danger d-print-none" key={index}>
                    {error.Message}&nbsp;
                    {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                </div>
            })}
            {this.state.warnings.map((warning, index) => {
                return <div className="alert alert-warning d-print-none" key={index}>
                    {warning.Message}&nbsp;
                    {warning.Link && <Link to={warning.Link} className="alert-link">Adjust Here</Link>}
                </div>
            })}
            {this.state.receipts.map((receipt, index) => {
                return <Receipt receipt={receipt} key={index} />
            })}
            {this.state.receipts.length === 0 && <h4 className="text-center">No Receipts Found.</h4>}
        </React.Fragment>
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        let year = parseInt(this.props.match.params.year) || 0;
        this.requestReceipts(accountId, year);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;
        let year = parseInt(this.props.match.params.year) || 0;

        if (this.state.receipts && (this.state.accountId != accountId || this.state.year != year)) {
            this.requestReceipts(accountId, year);
        }
    }

    public requestReceipts(accountId: number, year: number) {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            AccountID: accountId
        }
        if (data.FacilityID) {
            fetchApi(`api/Account/TaxReceipt/${year}/`, data, 'POST')
                .then((data: { IsGenerated: boolean, Receipts: ReceiptData[], Errors: AlertData[], Warnings: AlertData[] }) => {
                    this.setState({ receipts: data.Receipts, errors: data.Errors, warnings: data.Warnings, accountId, year });
                });
        } else {
            this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }]})
        }
    }

    private generate() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            AccountID: this.state.accountId
        }
        this.setState({ isLoading: true });
        fetchApi(`api/Account/GenerateReceipt/${this.state.year}`, data, 'POST')
            .then(() => {
                this.props.history.push(`/accounts/${this.state.accountId}/receipts`);
             })
            .catch(() => { alert("Failed to finalize receipt.") });
    }
}
